import React, { useState, useEffect } from "react";

export const svg = `<svg width="33" height="32" viewbox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M10.89 2.457c-1.102.456-1.97 1.324-3.704 3.058L6.015 6.686C4.28 8.42 3.413 9.288 2.957 10.39 2.5 11.493 2.5 12.72 2.5 15.172v1.656c0 2.453 0 3.68.457 4.782.456 1.102 1.324 1.97 3.058 3.704l1.171 1.171c1.734 1.735 2.602 2.602 3.704 3.058 1.103.457 2.33.457 4.782.457h1.656c2.453 0 3.68 0 4.782-.457 1.102-.456 1.97-1.323 3.704-3.058l1.171-1.171c1.735-1.735 2.602-2.602 3.058-3.704.457-1.103.457-2.33.457-4.782v-1.656c0-2.453 0-3.68-.457-4.782-.456-1.102-1.323-1.97-3.058-3.704l-1.171-1.171c-1.735-1.734-2.602-2.602-3.704-3.058C21.007 2 19.78 2 17.328 2h-1.656c-2.453 0-3.68 0-4.782.457ZM14.611 9.1a1 1 0 0 1 .996-1.1h1.79a1 1 0 0 1 .995 1.1l-.8 8.002a1 1 0 0 1-.995.9h-.19a1 1 0 0 1-.995-.9l-.8-8.002Zm1.891 14.904a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
